import { useBulkImportVendors } from '@nbfc-expense-tool/data-store/dashboard';
import {
  Box,
  BreadcrumbItem,
  Breadcrumbs,
  SecondaryHeader,
  Stack,
} from '@nbfc-expense-tool/ui';
import React from 'react';
import { BulkImportEntities } from '../../Common';

const BulkImportVendors: React.FC = () => {
  const { goBack } = useBulkImportVendors();

  return (
    <Box paddingX="5" paddingY="4">
      <Stack display="flex" flex="1" width="full">
        <Breadcrumbs>
          <BreadcrumbItem isCurrent={false} isFirst onClick={goBack}>
            Vendors
          </BreadcrumbItem>
          <BreadcrumbItem isCurrent>Vendors Bulk Import</BreadcrumbItem>
        </Breadcrumbs>
        <SecondaryHeader
          onClickBack={goBack}
          headingText="Vendors Bulk Import"
        />
      </Stack>
      <BulkImportEntities entityType="vendors" marginTop="3" />
    </Box>
  );
};

export default BulkImportVendors;
